export default __webpack_public_path__ + "static/media/atc-logo.cc7d901e.png";